"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetTokenDropArea = exports.WidgetTokenDropAreaSize = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var mobx_1 = require("mobx");
var VariableLabel_1 = __importStar(require("../VariableLabel/VariableLabel"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var withPolyfill_1 = __importDefault(require("react-resize-detector/build/withPolyfill"));
var WidgetTokenDropAreaSize;
(function (WidgetTokenDropAreaSize) {
    WidgetTokenDropAreaSize["Medium"] = "medium";
    WidgetTokenDropAreaSize["Large"] = "large";
    WidgetTokenDropAreaSize["Auto"] = "auto";
})(WidgetTokenDropAreaSize = exports.WidgetTokenDropAreaSize || (exports.WidgetTokenDropAreaSize = {}));
var WidgetTokenDropArea = (function (_super) {
    __extends(WidgetTokenDropArea, _super);
    function WidgetTokenDropArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasTokenDragOver = false;
        _this.hasCustomDragOver = false;
        _this.contentWidth = 0;
        _this.onDropAreaClick = function (event) {
            if (_this.props.variableName) {
                return;
            }
            else if (_this.props.onDropAreaClick != undefined) {
                _this.props.onDropAreaClick(event);
            }
        };
        _this.onDragOver = function (event) {
            var _a, _b;
            var types = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.types;
            if ((_b = _this.props.customDragDrop) === null || _b === void 0 ? void 0 : _b.isSupportedType(event)) {
                _this.hasCustomDragOver = true;
            }
            else if (!_this.props.customDragDrop && (types === null || types === void 0 ? void 0 : types.length) === 1 && (types === null || types === void 0 ? void 0 : types[0]) === "application/json") {
                _this.hasTokenDragOver = true;
            }
            else {
                _this.removeHoverMessage();
            }
        };
        _this.getClassSizeFromPixels = function (pixelWidth) {
            if (pixelWidth === 0 || pixelWidth > 300) {
                return VariableLabel_1.VariableLabelSize.Normal;
            }
            else if (160 < pixelWidth && pixelWidth <= 300) {
                return VariableLabel_1.VariableLabelSize.Small;
            }
            else {
                return VariableLabel_1.VariableLabelSize.Tiny;
            }
        };
        _this.onDrop = function (event) {
            _this.removeHoverMessage();
            _this.props.onDrop(event);
        };
        _this.removeHoverMessage = function () {
            _this.hasTokenDragOver = false;
            _this.hasCustomDragOver = false;
        };
        _this.handleResize = function (width) {
            _this.contentWidth = width;
        };
        return _this;
    }
    Object.defineProperty(WidgetTokenDropArea.prototype, "hasDragOver", {
        get: function () {
            return this.hasTokenDragOver || this.hasCustomDragOver;
        },
        enumerable: false,
        configurable: true
    });
    WidgetTokenDropArea.prototype.render = function () {
        return (react_1.default.createElement(withPolyfill_1.default, { onResize: this.handleResize },
            react_1.default.createElement("div", { className: (0, classnames_1.default)("token-drop-area", {
                    "token-drop-area--selected": this.props.isSelected,
                    "token-drop-area--drag": this.hasDragOver,
                    "token-drop-area--inner-selected": this.props.selectedEmptyInner,
                    "token-drop-area--borderless": this.props.borderless,
                }, "token-drop-area--size-".concat(this.getClassSizeFromPixels(this.contentWidth))), contentEditable: false }, this.renderInner())));
    };
    WidgetTokenDropArea.prototype.renderInner = function () {
        if (this.props.variableName) {
            return (react_1.default.createElement("div", { className: "token-drop-area__inner-area", onDrop: this.props.onDrop },
                react_1.default.createElement("div", { className: "token-drop-area__message-container center" },
                    react_1.default.createElement(VariableLabel_1.default, { Icon: this.props.icon, label: this.props.variableName, size: this.getClassSizeFromPixels(this.contentWidth) }))));
        }
        else {
            var Icon = this.props.icon;
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)("token-drop-area__drop-area token-drop-area__inner-area center", "token-drop-area__inner-area--".concat(this.props.size)), onMouseDown: this.onDropAreaClick, onDrop: this.onDrop, onDragOver: this.onDragOver, onDragLeave: this.removeHoverMessage },
                react_1.default.createElement("div", { className: "token-drop-area__message-container center" },
                    react_1.default.createElement("div", { className: "token-drop-area__drop-area-icon-area" },
                        react_1.default.createElement(Icon, { className: "token-drop-area__drop-area-icon", size: icons_1.IconSize.Large })),
                    react_1.default.createElement(react_transition_group_1.TransitionGroup, { component: null },
                        !this.hasDragOver && (react_1.default.createElement(react_transition_group_1.CSSTransition, { in: !this.hasDragOver, timeout: kaleidoscope_1.AnimationDuration.Short, classNames: "token-drop-area__explainer-", mountOnEnter: true, unmountOnExit: true },
                            react_1.default.createElement("div", { className: "token-drop-area__explainer" }, this.props.instructions))),
                        this.hasDragOver && (react_1.default.createElement(react_transition_group_1.CSSTransition, { mountOnEnter: true, unmountOnExit: true, in: this.hasDragOver, timeout: kaleidoscope_1.AnimationDuration.Short, classNames: "token-drop-area__explainer-" },
                            react_1.default.createElement("div", { className: "token-drop-area__hover-message token-drop-area__explainer" }, this.explainerMessage)))))));
        }
    };
    Object.defineProperty(WidgetTokenDropArea.prototype, "explainerMessage", {
        get: function () {
            var _a;
            if (this.hasTokenDragOver) {
                return "Release to add token";
            }
            else if (this.hasCustomDragOver) {
                return ((_a = this.props.customDragDrop) === null || _a === void 0 ? void 0 : _a.customDragMessage) || "";
            }
            else {
                return "";
            }
        },
        enumerable: false,
        configurable: true
    });
    WidgetTokenDropArea.defaultProps = {
        size: WidgetTokenDropAreaSize.Large,
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], WidgetTokenDropArea.prototype, "hasTokenDragOver", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], WidgetTokenDropArea.prototype, "hasCustomDragOver", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], WidgetTokenDropArea.prototype, "contentWidth", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], WidgetTokenDropArea.prototype, "hasDragOver", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], WidgetTokenDropArea.prototype, "onDragOver", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], WidgetTokenDropArea.prototype, "onDrop", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], WidgetTokenDropArea.prototype, "removeHoverMessage", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], WidgetTokenDropArea.prototype, "explainerMessage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], WidgetTokenDropArea.prototype, "handleResize", void 0);
    WidgetTokenDropArea = __decorate([
        mobx_react_1.observer
    ], WidgetTokenDropArea);
    return WidgetTokenDropArea;
}(react_1.default.Component));
exports.WidgetTokenDropArea = WidgetTokenDropArea;
